export const isPaymentConfirmed = (result, orderId) =>
  result?.status === "ok" &&
  !result.error &&
  Number.isSafeInteger(Number(result.order_id)) &&
  Number(result.order_id) > 0 &&
  Number(result.order_id) === Number(orderId);

const fieldNames = {
  delivery_email: "Email",
  delivery_phone: "Номер телефону",
  delivery_first_name: "Ім’я",
  delivery_last_name: "Прізвище",
  delivery_city: "Місто",
  delivery_branch: "Відділення",
  bonuses: "Бали",
  cart: "Кошик",
  order_id: "Замовлення",
};

export function confirmedReceipt(result) {
  const receipt = result?.receipt;
  if (!receipt || !isPaymentConfirmed(result, receipt.order_id) ||
      !Number.isSafeInteger(receipt.charged_points) || receipt.charged_points < 0 ||
      (receipt.balance_after !== null && !Number.isSafeInteger(receipt.balance_after))) return null;
  return {
    order_id: receipt.order_id,
    charged_points: receipt.charged_points,
    balance_after: receipt.balance_after,
    reward_types: Array.isArray(receipt.reward_types)
      ? receipt.reward_types.filter((type) => type === "physical" || type === "digital") : [],
  };
}

export function checkoutErrorMessage(error) {
  if (error.checkoutMessage) return error.checkoutMessage;
  if (error.status === 401) return "Сесія завершилася. Відкрийте магазин через Telegram.";
  if (error.status === 403) return "Немає доступу до цього замовлення.";
  if (error.status >= 500) return "Не вдалося завершити оформлення. Перевірте результат і спробуйте ще раз.";
  const details = error.details?.errors || error.details;
  if (details && typeof details === "object") {
    const messages = Object.keys(fieldNames).filter((key) => details[key])
      .map((key) => `${fieldNames[key]}: ${[].concat(details[key]).join(" ")}`);
    if (messages.length) return messages.join("\n");
  }
  return "Не вдалося підтвердити покупку. Перевірте з’єднання та спробуйте ще раз.";
}

export function checkoutError(message) {
  const error = new Error(message);
  error.checkoutMessage = message;
  return error;
}

export function checkoutReview(cart, customer, order = null) {
  if (order && (!Array.isArray(order.items) || order.total == null)) {
    throw checkoutError("Сервер не повернув підсумок замовлення. Зверніться до представника перед оплатою.");
  }
  const products = Array.isArray(cart) ? cart : [];
  const source = Array.isArray(order?.items) ? order.items : products;
  const items = source.map(item => {
    const product = typeof item.product_id === "object" ? item.product_id
      : products.find(row => Number(row.product_id.id) === Number(item.product_id))?.product_id;
    const id = Number(product?.id || item.product_id);
    const quantity = Number(item.quantity);
    const rawPrice = order ? item.price : product?.price;
    const price = Number(rawPrice);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1 ||
        rawPrice == null || rawPrice === "" || !Number.isFinite(price) || price < 0) throw checkoutError("Не вдалося перевірити склад замовлення. Поверніться до кошика.");
    return { id, name: product?.name || `Винагорода №${id}`, type: product?.type || "", quantity, price };
  }).sort((a, b) => a.id - b.id);
  const balance = Number(customer?.bonuses);
  const total = items.reduce((sum, item) => sum + item.quantity * item.price, 0);
  if (!items.length || customer?.bonuses == null || customer.bonuses === "" || !Number.isFinite(balance) || !Number.isFinite(total) ||
      (order?.total != null && Number(order.total) !== total)) {
    throw checkoutError("Не вдалося перевірити підсумок замовлення. Поверніться до кошика.");
  }
  return { items, balance, total, quantity: items.reduce((sum, item) => sum + item.quantity, 0), remaining: balance - total };
}

export function sameCheckoutReview(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function checkoutReviewChanged() {
  const error = checkoutError("Кошик або баланс змінилися. Перегляньте оновлений підсумок і підтвердьте покупку ще раз.");
  error.reviewChanged = true;
  return error;
}
